import api from "../api";

const compact = (value, depth = 0) => {
  if (depth > 5) return undefined;
  if (Array.isArray(value)) return value.slice(0, 250).map((item) => compact(item, depth + 1));
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value)
        .slice(0, 120)
        .map(([key, item]) => [key, compact(item, depth + 1)])
        .filter(([, item]) => item !== undefined),
    );
  }
  if (typeof value === "string") return value.slice(0, 4000);
  return value;
};

const AIInsightsService = {
  async generate(module, data, prompt = "") {
    const response = await api.post("/ai/module-insights", {
      module,
      prompt,
      data: compact(data),
    });
    return response.data;
  },
};

export default AIInsightsService;
